import * as React from 'react';
import TextField from '../../Base/TextField/TextField';
import NumberField from '../components/NumberField';
import FormControl from '../FormControl';
import { useMagicItemRules } from '../../../Modules/MagicForm/Hooks/useMagicItemRules';
import { ItemScheme } from '../MagicFormItem';
import InputField from '../components/InputField';

interface MagicFieldTextFieldProps {
	name?: string;
	itemScheme: ItemScheme;
	disabled?: boolean;
	showCharCounter?: boolean;
}

const MagicFieldTextField: React.FC<MagicFieldTextFieldProps> = ({
	itemScheme,
	name,
	disabled,
	showCharCounter,
}) => {
	const { maxLength } = useMagicItemRules(itemScheme);
	const label = itemScheme?.label || itemScheme?.title;

	let component;

	switch (itemScheme?.subType || itemScheme?.subtype) {
		case 'number':
			component = (
				<NumberField
					name={name ?? itemScheme?.key}
					suffix={itemScheme?.settings?.suffix}
					min={itemScheme?.settings?.min}
					max={itemScheme?.settings?.max}
					step={itemScheme?.settings.step}
					placeholder={itemScheme?.settings?.placeholder}
					disabled={disabled}
					charactersLimit={maxLength}
					showCharCounter={showCharCounter}
				/>
			);
			break;
		default:
			component = (
				<InputField
					name={name ?? itemScheme?.key}
					suffix={itemScheme?.settings?.suffix}
					placeholder={itemScheme?.settings?.placeholder}
					disabled={disabled}
					charactersLimit={maxLength}
					showCharCounter={showCharCounter}
				/>
			);
			break;
	}

	return (
		<FormControl
			label={label}
			name={name ?? itemScheme?.key}
			inLine={itemScheme?.inLine}
			isRequired={itemScheme?.settings?.required}
			hideRequired={itemScheme?.settings?.hideRequired ?? false}>
			{component}
		</FormControl>
	);
};

export default MagicFieldTextField;
